module.exports = __webpack_public_path__ + "assets/8bf7a9f53b860e12bb7e658e593b0aa9.png";